import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroImage, price } from '../data/salesPage';
export function Hero() {
  const reduce = useReducedMotion();
  const ease = [0.23, 1, 0.32, 1] as const;
  return <header className="relative overflow-hidden bg-ink" data-id="element-83" data-mp="9igvb8esxojn">
      <div className="mx-auto max-w-5xl px-5 pb-20 pt-14 text-center sm:pt-20" data-id="element-84" data-mp="4n1jem0cu2pv">
        <p className="font-display text-sm font-bold uppercase tracking-[0.25em] text-lime" data-id="element-85" data-mp="129qrndlnhbk6">Método 45 días</p>

        <motion.h1 initial={reduce ? false : {
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="mt-6 font-display text-5xl font-black uppercase leading-[0.95] tracking-tight text-bone sm:text-7xl lg:text-8xl" data-id="element-86" data-mp="xbpch3rchwdz">
          Cómo perder grasa
          <span className="block text-lime" data-id="element-87" data-mp="3cz5to748dry8">en 45 días</span>
        </motion.h1>

        <p className="mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-bone-muted sm:text-xl" data-id="element-88" data-mp="3814alm6t1smr">
          El método práctico para ordenar tu alimentación, entrenar mejor y construir hábitos que te ayuden a transformar tu cuerpo.
        </p>

        <motion.img src={heroImage} alt="Pack Cómo perder grasa en 45 días: 6 volúmenes, versión tablet y planificador de 45 días" initial={reduce ? false : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease,
        delay: 0.08
      }} className="mx-auto mt-10 w-full max-w-3xl" data-id="element-89" data-mp="39al8kaui8i1k" />

        <p className="mx-auto mt-8 max-w-xl font-display text-2xl font-extrabold leading-tight text-bone sm:text-3xl" data-id="element-90" data-mp="2qjv8sv08dbcx">
          45 días. Un plan. <span className="text-lime" data-id="element-91" data-mp="2vjzqupgsee59">Una estructura clara para dejar de improvisar.</span>
        </p>

        <div className="mt-10 flex flex-col items-center gap-4" data-id="element-92" data-mp="2hk85g3nxxvh8">
          <CtaButton data-id="element-93" data-mp="2lkin4dl3iabx" />
          <p className="text-sm text-bone-dim" data-id="element-94" data-mp="2ll0fv08ju6f3">
            Acceso al sistema completo por <span className="font-semibold text-bone" data-id="element-95" data-mp="s1rt2qgj2avc">{price.current}</span>
            <span className="mx-2" aria-hidden="true" data-id="element-96" data-mp="s3us1zznrec7">·</span>
            <span className="font-semibold text-bone-muted line-through decoration-alert decoration-2" data-id="element-97" data-mp="najj9tbacnhn">{price.reference}</span>
          </p>
        </div>
      </div>
    </header>;
}